module.exports = __webpack_public_path__ + "static/media/rectangle_icon.e3c7a046.cur";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/cursors/rectangle_icon.cur
// module id = 2314
// module chunks = 0